<template>
  <header class="z-30 w-full px-2 py-4 bg-white sm:px-4">
    <div class="flex items-center justify-end mx-auto max-w-7xl">
      <a v-if="invoiceSwitchUrl && canAccessInvoice" :href="invoiceSwitchUrl"
        class="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-primary text-sm font-semibold text-primary bg-white hover:bg-primary/5 transition-colors">
        e-Kolay Tahsilat Fatura
        <span aria-hidden="true">↗</span>
      </a>
    </div>
  </header>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { portalLinksEnabled, resolvePlatformUrl } from "@/utils/tenant";

export default defineComponent({
  data() {
    return {
      open: false,
    };
  },
  computed: {
    canAccessInvoice(): boolean {
      try {
        const stored = localStorage.getItem("userInfo");
        if (!stored) return false;
        const user = JSON.parse(stored);
        return !!user?.CanAccessEInvoicePayment;
      } catch {
        return false;
      }
    },
    invoiceSwitchUrl(): string {
      if (!portalLinksEnabled()) return "";
      const base = resolvePlatformUrl("https://portal.finmony.com").replace(/\/$/, "");
      return base ? `${base}/product-switch?target=e-kolay-tahsilat-invoice` : "";
    }
  }
});
</script>
